<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>ساخت دسته بندی   </template>
                </m-h5><m-category-form-1 v-bind='{...{},...{}}' :style='""' class="" ></m-category-form-1></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mCategoryForm1 from '@moeinmdn/miw-alpha-components/src/package/Dashboard/Category/Form/CategoryForm1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mH5,mCategoryForm1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
